<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-select v-model="model.ConfigurationType" 
                                      label="Configuration Type *" 
                                       
                                       
                                      :options="dataSourceCustomerConfigurationType" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[]"
                                      :error="fieldHasError('ConfigurationType')"
                                      :error-message="fieldErrorMessage('ConfigurationType')"
                                      
                                      @input="onConfigurationTypeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" v-show="model.ConfigurationType === 0">
                            <q-select v-model="model.RootSeller" 
                                      label="Vendor *" 
                                       
                                       
                                      :options="dataSourceLookupTradingPartners" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[val => model.ConfigurationType === 0 ? !!val || 'Required' : true,]"
                                      :error="fieldHasError('RootSeller')"
                                      :error-message="fieldErrorMessage('RootSeller')"
                                      reactive-rules
                                      @input="onRootSellerChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" v-show="model.ConfigurationType === 1">
                            <q-select v-model="model.RootWarehouse" 
                                      label="Warehouse *" 
                                       
                                       
                                      :options="dataSourceLookupTradingPartners" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[val => model.ConfigurationType === 1 ? !!val || 'Required' : true,]"
                                      :error="fieldHasError('RootWarehouse')"
                                      :error-message="fieldErrorMessage('RootWarehouse')"
                                      reactive-rules
                                      @input="onRootWarehouseChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" v-show="model.ConfigurationType === 0">
                            <q-select v-model="model.SalesChannels" 
                                      label="Sales Channels" 
                                       
                                       
                                      :options="dataSourceLookupTradingPartners" option-value="Key" option-label="Value"
                                      emit-value map-options multiple
                                       
                                      :rules="[]"
                                      :error="fieldHasError('SalesChannels')"
                                      :error-message="fieldErrorMessage('SalesChannels')"
                                      
                                      @input="onSalesChannelsChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" v-show="model.ConfigurationType === 0">
                            <q-select v-model="model.Warehouses" 
                                      label="Warehouses" 
                                       
                                       
                                      :options="dataSourceLookupTradingPartners" option-value="Key" option-label="Value"
                                      emit-value map-options multiple
                                       
                                      :rules="[]"
                                      :error="fieldHasError('Warehouses')"
                                      :error-message="fieldErrorMessage('Warehouses')"
                                      
                                      @input="onWarehousesChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" v-show="model.ConfigurationType === 1">
                            <q-select v-model="model.Sellers" 
                                      label="Vendors" 
                                       
                                       
                                      :options="dataSourceLookupTradingPartners" option-value="Key" option-label="Value"
                                      emit-value map-options multiple
                                       
                                      :rules="[]"
                                      :error="fieldHasError('Sellers')"
                                      :error-message="fieldErrorMessage('Sellers')"
                                      
                                      @input="onSellersChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-12" >
                            <q-checkbox v-model="model.BypassSKUDuplicateCheck" 
                                        label="Bypass Duplicate Check" 
                                         
                                        
                                        
                                        dense>
                                
                                
                            </q-checkbox>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './skumapsettingseditmodel-dialog-screen.js'
</script>